import { formatTime } from "@/lib/utils";
import { CooldownTrainType } from "@ailenax-overlay/shared";
import { FC, useCallback, useEffect, useState } from "react";

interface CooldownProps {
    train: CooldownTrainType;
    offset: number;
}

export const Cooldown: FC<CooldownProps> = ({ train, offset }) => {
    const [timeRemaining, setTimeRemaining] = useState<number>(0);

    const updateTime = useCallback(() => {
        const now = new Date();
        const msRemaining = train.cooldownReadyAt.getTime() - now.getTime() - offset;
        setTimeRemaining(~~(msRemaining / 1000));
    }, [train, offset]);

    useEffect(() => {
        updateTime();
        const interval = setInterval(updateTime, 1000);

        return () => clearInterval(interval);
    }, [updateTime]);
    
    return (
        <div className="w-[100%] h-[100%] px-3 flex flex-col justify-center items-center text-2xl">
            <div className="flex flex-row items-center justify-between">
                <div className="flex-1">
                    Donation
                    <span style={{ marginLeft: "5px" }}>Hype Train <span className="dono-train-cooldown-text">COOLDOWN</span>!</span>
                </div>
                <div className="w-25 text-end text-3xl">
                    { formatTime(Math.max(0, timeRemaining)) }
                </div>
            </div>
        </div>
    );
}